<template>
  <main class="flex-1">
    <div class="prof-wrap">
      <div class="prof-inner">

        <!-- Page header -->
        <div class="prof-page-header">
          <h1 class="prof-page-title">Account Settings</h1>
        </div>

        <!-- Tabs (mobile) -->
        <div class="lg:hidden">
          <label for="selected-tab" class="sr-only">Select a tab</label>
          <select id="selected-tab" name="selected-tab" class="prof-tab-select">
            <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
          </select>
        </div>

        <!-- Tabs (desktop) -->
        <div class="hidden lg:block">
          <div class="prof-tabs">
            <nav class="prof-tabs__nav">
              <a
                v-for="tab in tabs"
                :key="tab.name"
                :href="tab.href"
                :class="['prof-tab', tab.current ? 'prof-tab--active' : '']"
              >
                {{ tab.name }}
              </a>
            </nav>
          </div>
        </div>

        <!-- Profile info -->
        <div class="prof-section">
          <div class="prof-section__header">
            <h3 class="prof-section__title">Profile</h3>
            <p class="prof-section__sub">This information will be displayed publicly so be careful what you share.</p>
          </div>
          <dl class="prof-fields">
            <div class="prof-field">
              <dt class="prof-field__label">Name</dt>
              <dd class="prof-field__value">{{ this.getFullName }}</dd>
            </div>
            <div class="prof-field">
              <dt class="prof-field__label">Email</dt>
              <dd class="prof-field__value">{{ this.getEmail }}</dd>
            </div>
          </dl>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import {mapGetters} from "vuex";

const tabs = [
  { name: 'General', href: '#', current: true },
  { name: 'Password', href: '#', current: false },
]

export default {
  name: "profilePage",
  data() {
    return {
      tabs
    }
  },
  computed: {
    ...mapGetters(["getFullName", "getEmail"]),
  }
}
</script>

<style scoped>
.prof-wrap { max-width: 56rem; margin: 0 auto; padding: 0 1rem; font-family: 'Barlow', sans-serif; }
.prof-inner { padding: 2.5rem 0; }

.prof-page-header {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid var(--cc-sep);
  margin-bottom: 1.5rem;
  transition: border-color 0.3s;
}
.prof-page-title {
  font-family: 'Big Shoulders Display', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  color: var(--cc-t1);
  margin: 0;
  transition: color 0.3s;
}

.prof-tab-select {
  margin-top: 0.25rem;
  display: block;
  width: 100%;
  padding: 0.5rem 2.5rem 0.5rem 0.75rem;
  background: var(--cc-input);
  border: 1px solid var(--cc-input-border);
  border-radius: 3px;
  color: var(--cc-input-text);
  font-family: 'Barlow', sans-serif;
  font-size: 0.875rem;
  outline: none;
  transition: background 0.3s, border-color 0.3s, color 0.3s;
}

.prof-tabs { border-bottom: 1px solid var(--cc-sep); margin-bottom: 2.5rem; transition: border-color 0.3s; }
.prof-tabs__nav { display: flex; }
.prof-tab {
  white-space: nowrap;
  padding: 1rem 0;
  margin-right: 2rem;
  border-bottom: 2px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--cc-t3);
  text-decoration: none;
  transition: border-color 0.18s, color 0.18s;
}
.prof-tab:hover { color: var(--cc-t2); border-bottom-color: var(--cc-sep); }
.prof-tab--active { border-bottom-color: #0092bf; color: #0092bf; }

.prof-section__header { margin-bottom: 0.75rem; }
.prof-section__title { font-size: 1.0625rem; font-weight: 600; color: var(--cc-t6); margin: 0 0 0.25rem; transition: color 0.3s; }
.prof-section__sub { font-size: 0.8125rem; color: var(--cc-t3); margin: 0; transition: color 0.3s; }

.prof-fields { border-top: 1px solid var(--cc-sep); margin-top: 0.75rem; transition: border-color 0.3s; }
.prof-field {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  padding: 1.125rem 0;
  border-bottom: 1px solid var(--cc-sep);
  align-items: start;
  transition: border-color 0.3s;
}
.prof-field__label { font-size: 0.8125rem; font-weight: 500; color: var(--cc-t3); transition: color 0.3s; }
.prof-field__value { font-size: 0.8125rem; color: var(--cc-t6); transition: color 0.3s; }
</style>